import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center gap-2">
    {[1, 2].map(i => (
      <div key={i} className="flex items-center gap-1.5 bg-zinc-200 dark:bg-zinc-700 rounded p-1.5">
        <div className="w-3 h-3 bg-primary/30 rounded" />
        <div className="flex flex-col gap-0.5">
          <div className="w-6 h-1 bg-zinc-300 dark:bg-zinc-600 rounded" />
          <div className="w-4 h-1 bg-zinc-300 dark:bg-zinc-600 rounded" />
        </div>
      </div>
    ))}
  </div>
);

export default Thumbnail;
